module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "close-icon-white.ebb3e990.svg";